import { all } from "redux-saga/effects";
import { combineReducers } from "redux";

import * as auth from "../app/modules/Auth/_redux/authRedux";
import { customersSlice } from "../app/modules/ECommerce/_redux/customers/customersSlice";
import { productsSlice } from "../app/modules/ECommerce/_redux/products/productsSlice";
import { remarksSlice } from "../app/modules/ECommerce/_redux/remarks/remarksSlice";
import { specificationsSlice } from "../app/modules/ECommerce/_redux/specifications/specificationsSlice";

import { historySlice } from "../app/modules/History/history-redux/historySlice";
import { userSlice } from "../app/modules/User/user-redux/userSlice";
import { withdrawSlice } from "../app/modules/Withdraw/withdraw-redux/withdrawSlice";
import { bankAccountSlice } from "../app/modules/BankAccount/bankAccount-redux/bankAccountSlice";
import { subAdminSlice } from "../app/modules/SubAdmin/subAdmin-redux/subAdminSlice";
import { countrySlice } from "../app/modules/Country/country-redux/countrySlice";
import { bankSlice } from "../app/modules/Bank/bank-redux/bankSlice";
import { citySlice } from "../app/modules/City/city-redux/citySlice";
import { stateSlice } from "../app/modules/State/state-redux/stateSlice";
import { reportAbuseSlice } from "../app/modules/ReportAbuse/reportAbuse-redux/reportAbuseSlice";
import { accessLogSlice } from "../app/modules/AccessLog/accessLog-redux/accessLogSlice";
import { transactionsReportSlice } from "../app/modules/Reports/Transactions Report/transactions-report-redux/transactionsReportSlice";
import { clearingAccountReportSlice } from "../app/modules/Reports/Clearing Account Report/clearing-account-report-redux/clearingAccountReportSlice";

export const rootReducer = combineReducers({
  auth: auth.reducer,
  customers: customersSlice.reducer,
  products: productsSlice.reducer,
  remarks: remarksSlice.reducer,
  specifications: specificationsSlice.reducer,
  history: historySlice.reducer,
  user: userSlice.reducer,
  withdraw: withdrawSlice.reducer,
  bankAccount: bankAccountSlice.reducer,
  subAdmin: subAdminSlice.reducer,
  country: countrySlice.reducer,
  bank: bankSlice.reducer,
  city: citySlice.reducer,
  state: stateSlice.reducer,
  reportAbuse: reportAbuseSlice.reducer,
  accessLog: accessLogSlice.reducer,
  transactionsReport: transactionsReportSlice.reducer,
  clearingAccountReport: clearingAccountReportSlice.reducer
});

export function* rootSaga() {
  yield all([auth.saga()]);
}
